<script setup lang="ts">
import { type Component, computed } from 'vue'
import { type SidebarMenuButtonProps } from './menu-button-child.vue'
import { useSidebar } from './utils'

defineOptions({
	inheritAttrs: false,
})

const props = withDefaults(defineProps<SidebarMenuButtonProps & {
	tooltip?: string | Component
}>(), {
	as: 'button',
	variant: 'default',
	size: 'default',
})

const { isMobile, state } = useSidebar()

const delegatedProps = computed(() => {
	const { tooltip, ...delegated } = props
	return delegated
})
</script>

<template>
	<ui-sidebar-menu-button-child v-if="!tooltip" v-bind="{ ...delegatedProps, ...$attrs }">
		<slot />
	</ui-sidebar-menu-button-child>

	<ui-tooltip v-else>
		<ui-tooltip-trigger as-child>
			<ui-sidebar-menu-button-child v-bind="{ ...delegatedProps, ...$attrs }">
				<slot />
			</ui-sidebar-menu-button-child>
		</ui-tooltip-trigger>
		<ui-tooltip-content
			side="right"
			align="center"
			:hidden="state !== 'collapsed' || isMobile"
		>
			<template v-if="typeof tooltip === 'string'">
				{{ tooltip }}
			</template>
			<component :is="tooltip" v-else />
		</ui-tooltip-content>
	</ui-tooltip>
</template>
